import * as ActionTypes from '../../actions/allActions'

const forgotPasswordInit = {}
const forgotPassword = (state = forgotPasswordInit, action) => {
	switch (action.type) {
		case ActionTypes.FORGOTPASSWORD_METACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.FORGOTPASSWORD_SUCCESS:
			return { ...state, ...action.data.data }
		case ActionTypes.LOGOUT:
			return forgotPasswordInit
		default:
			return state
	}
}

export default forgotPassword


// WEBPACK FOOTER //
// ./src/reducers/metadata/forgotPassword.js